// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"1":"b160406a","375":"7583a46d","980":"ba0a295f"}[chunkId] + ".css";
};